// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__12Pfk","actionsCol":"EnrolledClinics_actionsCol__2AQBc"};